import { Box, Button, Paragraph, FoldOut } from '@folksam/ui-next/components';
import React, { useState } from 'react';

export default function GdprTextContainer() {
    //Hardcoded values since they are the same for all instances
    const gdprPricingInfoTitle = 'Ditt pris framställs automatiskt';
    const gdprPricingInfoText =
        'När du tecknar försäkring räknas ditt pris ut genom ett automatiskt beslut baserat på de uppgifter du lämnar. Mer information finns på folksam.se/personuppgifter. Har du frågor kan du kontakta oss.';

    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <Box marginTop={'5'}>
            <FoldOut
                text={''}
                icon={() => null}
                showBorder={false}
                expanded={isExpanded}
                onClick={() => setIsExpanded(!isExpanded)}
                sx={{
                    margin: 'auto',
                    maxWidth: '355px'
                }}
            >
                <FoldOut.Header
                    sx={{
                        fontSize: '11px',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        display: 'flex',
                        width: '100%',
                        gap: '0.5rem',
                        fontFamily: 'inter',
                        '&:hover': {
                            textDecoration: 'underline',
                            textUnderlineOffset: '4px'
                        },
                        '&:focus-visible:not(:active)': {
                            outline: '2px solid #003E80',
                            outlineOffset: '4px',
                            borderRadius: '3px'
                        }
                    }}
                >
                    {gdprPricingInfoTitle}
                    <Box sx={{ svg: { height: 18, width: 18 } }}>
                        <FoldOut.Header.Icon sx={{ g: { display: 'contents' } }} />
                    </Box>
                </FoldOut.Header>
                <FoldOut.Content>
                    <Paragraph sx={{ paddingTop: '8px', fontSize: '11px', fontFamily: 'inter' }}>
                        {gdprPricingInfoText}
                    </Paragraph>
                </FoldOut.Content>
            </FoldOut>
        </Box>
    );
}
